export default __webpack_public_path__ + "static/media/workedverywell.9057746f.png";